module.exports = __webpack_public_path__ + "img/17.65caa7ea.png";